"use client";

import { usePathname } from "next/navigation";
import CookieBanner from "@brochureflow/brochure-ui/components/CookieBanner";

/**
 * Verbergt de cookie-banner op klantportaal-routes (/brochure/[token]) — daar
 * komt de klant via een persoonlijke link uit mail/SMS na lead-signup. Banner
 * is post-conversion opdringerig en past niet bij de portal-UX. Op alle andere
 * routes wordt de banner normaal getoond.
 *
 * Tracking-consent voor de portal-pagina valt op terug op Consent Mode v2
 * default = denied (zie ConsentDefaultScript in layout) — er gaat dus geen
 * marketing/analytics cookie gezet zonder dat de klant elders al consent heeft
 * gegeven.
 */
const HIDE_PREFIXES = ["/brochure/"];

export default function ConditionalCookieBanner() {
  const pathname = usePathname();
  if (pathname && HIDE_PREFIXES.some((p) => pathname.startsWith(p))) {
    return null;
  }
  return <CookieBanner />;
}
